import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";

const BankList = () => {
  const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBanks = async () => {
    try {
      setLoading(true);
      const res = await api.get("banks/");
      setBanks(res.data);
    } catch (err) {
      console.error(err);
      setError("Error fetching banks!");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this bank?")) {
      try {
        await api.delete(`banks/${id}`);
        setBanks(banks.filter((bank) => bank.id !== id));
        alert("Bank deleted successfully!");
      } catch (err) {
        console.error("Error deleting bank:", err);
        alert("Failed to delete bank.");
      }
    }
  };

  useEffect(() => {
    fetchBanks();
  }, []);

  if (loading) return (
    <div className="container mt-4 text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-2">Loading bank list...</p>
    </div>
  );

  return (
    <div className="container mt-4">
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="mb-0 text-primary">Bank List</h2>
            <div>
              <button 
                className="btn btn-success me-2" 
                onClick={() => navigate("/dashboard/banks/new")}
              >
                + Add New Bank
              </button>
              <button className="btn btn-outline-secondary" onClick={() => navigate("/dashboard")}>
                Back to Dashboard
              </button>
            </div>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Bank Name</th>
                  <th>Branch</th>
                  <th>Accounts</th>
                  <th>Default</th>
                  <th>Invoice</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {banks.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4 text-muted">
                      No banks found.
                    </td>
                  </tr>
                ) : (
                  banks.map((bank, index) => (
                    <tr key={bank.id || index}>
                      <td><strong>{index + 1}</strong></td>
                      <td>{bank.name}</td>
                      <td>{bank.branch || '—'}</td>
                      <td>
                        <div className="small">
                          {bank.accounts && bank.accounts.length > 0 ? (
                            bank.accounts.map(acc => (
                              <div key={acc.id} className="mb-1 border-bottom pb-1 last-child-no-border">
                                <strong>{acc.account_title}</strong><br/>
                                <span className="text-muted">{acc.account_number}</span>
                              </div>
                            ))
                          ) : 'No accounts'}
                        </div>
                      </td>
                      <td>
                        <span className={`badge ${bank.is_default ? 'bg-success' : 'bg-light text-dark'}`}>
                          {bank.is_default ? 'Yes' : 'No'}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${bank.add_to_invoice ? 'bg-info' : 'bg-light text-dark'}`}>
                          {bank.add_to_invoice ? 'Yes' : 'No'}
                        </span>
                      </td>
                      <td>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(bank.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankList;
